// extracted by mini-css-extract-plugin
export default {"container":"component_form_barcode_container__yCyGA","subLabel":"component_form_barcode_subLabel__KcgKf","description":"component_form_barcode_description__PYmVJ"};